import { css } from '@bts-web/utils-style-engine';

export const submitButtonWrapper = css({
  position: 'sticky',
  bottom: 0,
  width: '100vw',
  pt: 'medium',
  pb: 'medium',
  px: {
    base: 'medium',
    lg: 0,
  },
  mt: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 'small',
  bg: 'screen_background.primary',
  marginLeft: '-24px',
  boxShadow: '0 -6px 12px rgba(158, 158, 158, 0.2)',
  '&[dir="rtl"]': {
    marginRight: '-24px',
  },
  lg: {
    position: 'static',
    width: '100%',
    marginLeft: 0,
    boxShadow: 'none',
    '&[dir="rtl"]': {
      marginRight: 0,
    },
  },
});

export const submitButtonWrapperAndButtonProperStyles = css({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mx: 'auto',
  maxWidth: '440px',
});
